import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';

import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { createBlacklistFilter } from 'redux-persist-transform-filter';

import authReducer from 'store/auth/reducer';
// import bookingTimeSlotReducer from 'store/booking/reducer';
import accountReducer from 'store/account/reducer';
import thankYouReducer from 'store/thankYou/reducer';
import onlineServiceReducer from 'store/onlineService/reducer';
import preferredSiteReducer from 'store/preferredSite/reducer';
import bookingReducer from 'store/booking/reducer';
import viewBookingReducer from 'store/viewBooking/reducer';

export default history => {
  const reducers = combineReducers({
    router: connectRouter(history),
    form: formReducer,
    auth: authReducer,
    account: accountReducer,
    thankYou: thankYouReducer,
    onlineService: onlineServiceReducer,
    preferredSite: preferredSiteReducer,
    booking: bookingReducer,
    viewBookings: viewBookingReducer,
  });

  const formBlacklistFilter = createBlacklistFilter('form', [
    'booking-form.registeredFields',
  ]);

  const viewBookingsFilter = createBlacklistFilter('viewBookings', [
    'patient.loading',
    'appointments.loading',
  ]);

  const persistConfig = {
    key: 'root',
    storage: storageSession,
    stateReconciler: autoMergeLevel2,
    blacklist: ['router'],
    transforms: [formBlacklistFilter, viewBookingsFilter],
  };

  return persistReducer(persistConfig, reducers);
};
